import Vue from 'vue';
import '../../../scss/critical.scss';
import '../../../scss/education.scss';
import {eventBus} from '../../lib/event-bus/event-bus';
import {CONTACT_US_OPEN_MODAL} from '../../lib-sat/contact-us/event';
import {registerPaymentModalHelper} from '../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper';
import {globalLogger} from '../../qaamgo/helper/global-logger';
import {userManager} from "../../lib-sat/user/user-manager";
import EducationValidation from "../../qaamgo/modules/sat/components/education/EducationValidation.vue";


const $ = require('jquery');
global.$ = global.jQuery = $;

$(document).ready(function () {
    import(
        /* webpackMode: "eager" */
        '../qg-main'
        ).then(async () => {
        import('../user/qg-contact-us');

        const contactUsButton = document.querySelectorAll('[data-education-contact-us]')[0];
        const startNowButtons = document.querySelectorAll('[data-user-button-login]');
        const educationValidationElement = document.getElementById('educationValidation');

        const user = await userManager.getUser();

        if (educationValidationElement) {
            new Vue({
                el: '#educationValidation',
                name: 'EducationValidationRoot',
                components: {
                    EducationValidation,
                },
                render(h) {
                    return h(EducationValidation);
                },
            });
        }


        if (contactUsButton) {
            contactUsButton.addEventListener('click', () => {
                globalLogger.log('educational page - contact us button - clicked');
                eventBus.emit(CONTACT_US_OPEN_MODAL);
            });
        }

        startNowButtons.forEach((button) => {
            if (user.isPremium()) {
                button.classList.add('hidden');
            }
            button.addEventListener('click', () => {
                globalLogger.log('educational page - start now button - clicked');
                registerPaymentModalHelper.openUpgrade();
            });
        });

    });
});
